import {
  QueryClient,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";
import { ProviderSakhadService } from "../../services/requests/providerSakhad";
import { handleResponse } from "./setup";
import Noti from "../../view/components/general/noti";
import { retry } from "redux-saga/effects";
import {
  SakhadVerifyOtpInitData,
  SakhadVerifyOtpType,
} from "../../types/sakhadAuth";
import {
  localStorageClear,
  localStorageGet,
  localStorageSet,
} from "../../utils/localStorage";
import { Provider, useDispatch } from "react-redux";
import { ROUTES } from "../../constants/constant/routes";
import { setFullName, setIsProvider } from "../../store/slice/userData";
import { useNavigate } from "react-router-dom";

const useSakhadSendOtp = () => {
  return useMutation({
    mutationFn: async (params: any) => {
      const response = await ProviderSakhadService.sakhadProvicerIsLoggedIn();
      const hasToken = response?.data?.result;
      if (hasToken === true) {
        return { isSkipped: true }; // وضعیت لاگین از قبل
      }

      // اگر لاگین نبود، درخواست OTP می‌فرستد
      return ProviderSakhadService.sakhadSendOtp(params);
    },
    onSuccess: (data: any) => {
      if (data?.isSkipped) {
        Noti("success", "شما به ساخد متصل هستید");
        return;
      }

      // مدیریت پاسخ استاندارد API
      handleResponse({
        data,
        onSuccess: () => {
          Noti("success", data?.data?.msg || "کد تایید ارسال شد");
        },
        onError: () => {
          Noti("error", data?.data?.msg || "خطا در ارسال کد");
        },
      });
    },
  });
};

const useSakhadLogin = (modalName?: boolean) => {
  return useQuery({
    queryKey: ["getSakhadLogin", modalName],
    queryFn: ({ queryKey }: any) => {
      const [_, params] = queryKey;
      return ProviderSakhadService.sakhadLogin(params);
    },
    enabled: modalName ?? true,
  });
};

const useSakhadVerifyOtp = () => {
  // const queryClient = useQueryClient();

  return useMutation<any, Error, SakhadVerifyOtpType>({
    mutationFn: (params) => ProviderSakhadService.sakhadVerifyOtp(params),
    onSuccess: (data: any) => {
      handleResponse({
        data,
        onSuccess: () => {
          // const resultData = data?.data?.result || {};
          // const {
          //   accessToken,
          //   expireAccessToken,
          //   sessionId,
          //   requestId,
          //   expireSessionId,
          // } = resultData;

          // const durationInSeconds = parseInt(expireAccessToken, 10);
          // const validDuration = !isNaN(durationInSeconds)
          //   ? durationInSeconds
          //   : 86400;

          // const expiresAt = Date.now() + validDuration * 1000;

          // const sakhadAuthData = {
          //   accessToken,
          //   expireAccessToken: expiresAt,
          //   sessionId,
          //   requestId,
          //   expireSessionId,
          // };

          // localStorageSet("SAKHAD_AUTH_DATA", sakhadAuthData);

          // queryClient.setQueryData(["sakhadAuthDataQuery"], accessToken);
          Noti("success", "اتصال به ساخد با موفقیت انجام شد.");
        },
        onError: () => {
          Noti("error", "خطا در تایید رمز دوم: " + data?.data?.msg);
        },
      });
    },
  });
};

const useSakhadConfirmLogin = () => {
  return useMutation({
    mutationFn: ProviderSakhadService.sakhadConfirm,
    onSuccess: (data: any) => {
      handleResponse({
        data,
        onSuccess: () => {
          const resultData = data?.data?.result || {};

          // const {
          //   accessToken,
          //   expireAccessToken,
          //   sessionId,
          //   requestId,
          //   expireSessionId,
          // } = resultData;

          // const durationInSeconds = parseInt(expireAccessToken, 10);
          // const validDuration = !isNaN(durationInSeconds)
          //   ? durationInSeconds
          //   : 86400;

          // const expiresAt = Date.now() + validDuration * 1000;

          // const sakhadAuthData = {
          //   accessToken,
          //   expireAccessToken: expiresAt,
          //   sessionId,
          //   requestId,
          //   expireSessionId,
          // };

          // localStorageSet("SAKHAD_AUTH_DATA", sakhadAuthData);
          Noti("success", "اتصال به ساخد با موفقیت انجام شد");
        },
        onError() {
          Noti("error", " :خطا در اتصال به ساخد" + data?.data?.msg);
        },
      });
    },
  });
};

export const useSakhadInquiryPrescription = () => {
  return useMutation({
    mutationFn: ProviderSakhadService.sakhadInquiryPrescription,
    onSuccess: (response: any) => {
      // 1. Check if status is 200
      if (response?.status === 200) {
        Noti("success", "استعلام اولیه نسخه ساخد با موفقیت انجام شد.");

        // You can still call handleResponse if it performs other logic (like state updates)
        handleResponse({
          data: response,
          onSuccess: () => {}, // logic already handled above
        });
      } else {
        // 2. Handle cases where status is not 200 (even if it entered onSuccess)
        const errorMsg = response?.data?.msg || "خطای ناشناخته";
        Noti("error", "خطا در استعلام اولیه نسخه ساخد: " + errorMsg);
      }
    },
    onError: (error: any) => {
      // 3. Handle actual network/server errors (4xx, 5xx)
      Noti("error", "خطای شبکه یا سرور رخ داده است.");
    },
  });
};

const useSakhadGetCaptcha = () => {
  return useMutation({
    mutationFn: ProviderSakhadService.sakhadGetCaptcha,
    onSuccess: (data: any) => {
      handleResponse({
        data,
        onSuccess: () => {
          Noti("success", "کپچا با موفقیت بروزرسانی شد");
        },
        onError() {
          Noti("error", "خطا در بروزرسانی کپچا");
        },
      });
    },
  });
};

// const isSakhadTokenValid = () => {
//   const authData = localStorageGet("SAKHAD_AUTH_DATA");

//   if (!authData || !authData.accessToken || !authData.expireAccessToken) {
//     return false; // No data or essential keys are missing
//   }

//   // The expiration time is already a timestamp, so we just compare it to now.
//   const isExpired = Date.now() >= authData.expireAccessToken;

//   return !isExpired;
// };

const useGetAllServiceListByType = () => {
  return useMutation({
    mutationFn: ProviderSakhadService.getAllServiceListByType,
    onSuccess: (data: any) => {
      handleResponse({
        data,
        onSuccess: () => {
          Noti("success", "اطلاعات خدمات ساخد با موفقیت دریافت شد.");
        },
        onError() {
          Noti("error", "خطا در دریافت اطلاعات خدمات ساخد");
        },
      });
    },
  });
};

const useSakhadVerifyCaptcha = () => {
  return useMutation({
    mutationFn: ProviderSakhadService.getSakhadVerifyCaptcha,
    onSuccess: (data: any) => {
      handleResponse({
        data,
        onSuccess: () => {
          Noti("success", "کپچا با موفقیت تایید شد.");
        },
        onError() {
          Noti("error", "خطا در تایید کپچا");
        },
      });
    },
  });
};

const useIsSakhadProviderLoggedIn = () => {
  return useMutation({
    mutationFn: ProviderSakhadService.sakhadProvicerIsLoggedIn,
    onSuccess: (data: any) => {
      handleResponse({
        data,
        onSuccess: () => {
          Noti("success", "بررسی توکن ساخد با موفقیت انجام شد");
        },
        onError() {
          Noti("error", "بررسی لاگین بودن در ساخد ناموفق بود");
        },
      });
    },
  });
};

const useSakhadGetSubHistory = () => {
  return useMutation({
    mutationFn: ProviderSakhadService.sakhadGetSubHistory,
    onSuccess: (data: any) => {
      handleResponse({
        data,
        onSuccess: () => {
          // Noti("success", "بررسی توکن ساخد با موفقیت انجام شد");
        },
        onError() {
          Noti("error", "خطا در دریافت ریزنسخ ساخد");
        },
      });
    },
  });
};

const useSakhadGetServiceByTypeAndCode = () => {
  return useMutation({
    mutationFn: ProviderSakhadService.sakhadGetServiceByTypeAndCode,
    onSuccess: (data: any) => {
      handleResponse({
        data,
        onSuccess: () => {
          // Noti("success", "بررسی توکن ساخد با موفقیت انجام شد");
        },
        onError() {
          Noti("error", "خطا در دریافت ریزنسخ ساخد");
        },
      });
    },
  });
};

const useSakhadGetAllConsumptionListByShape = () => {
  return useMutation({
    mutationFn: ProviderSakhadService.sakhadGetAllConsumptionListByShape,
    onSuccess: (data: any) => {
      handleResponse({
        data,
        onSuccess: () => {
          // Noti("success", "بررسی توکن ساخد با موفقیت انجام شد");
        },
        onError() {
          Noti("error", "خطا در دریافت ریزنسخ ساخد");
        },
      });
    },
  });
};

const useSakhadGetAllConsumptionInstructionListByShape = () => {
  return useMutation({
    mutationFn:
      ProviderSakhadService.sakhadGetAllConsumptionInstructionListByShape,
    onSuccess: (data: any) => {
      handleResponse({
        data,
        onSuccess: () => {
          // Noti("success", "بررسی توکن ساخد با موفقیت انجام شد");
        },
        onError() {
          Noti("error", "خطا در دریافت ریزنسخ ساخد");
        },
      });
    },
  });
};
// const useSakhadLogout = () => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();

//   return useMutation({
//     mutationFn: ProviderSakhadService.sakhadLogout,
//     onSettled: () => {
//       // This runs AFTER the request is finished
//       console.log("SAKHAD_Cleanup - API finished, now clearing local data");

//       // 1. Save what you need
//       let _siteSettingStorage = localStorageGet("SITE_SETTING");

//       // 2. Clear everything
//       localStorageClear();

//       // 3. Restore what you saved
//       localStorageSet("SITE_SETTING", _siteSettingStorage);

//       // 4. Update Redux
//       dispatch(setIsProvider(null));
//       dispatch(setFullName(""));

//       // 5. Finally, Redirect
//       navigate(ROUTES.LOGIN.PATH);
//     },
//     onSuccess: () => {
//       console.log("SAKHAD_18 - API Success");
//     },
//     onError: (error) => {
//       console.log(
//         "SAKHAD_19 - API Error (likely token already gone or invalid)",
//       );
//     },
//   });
// };

const useSakhadPrintPrescription = () => {
  return useMutation({
    mutationFn: ProviderSakhadService.sakhadPrintPrescription,
    onSuccess: async (response: any) => {
      // 1. CHECK IF THE CONTENT IS JSON (ERROR) INSTEAD OF PDF
      // If the server returns an error, the type will be "application/json"
      if (response.data.type === "application/json") {
        const text = await response.data.text(); // Convert blob to text
        const errorData = JSON.parse(text); // Parse JSON
        Noti("error", errorData.msg || "خطا در دریافت فایل");
        return;
      }

      // 2. PROCEED WITH PDF DOWNLOAD IF NOT JSON
      const contentDisposition = response.headers["content-disposition"];
      let fileName = "prescription.pdf";

      if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(/filename="?(.+?)"?$/);
        if (fileNameMatch?.[1]) {
          fileName = fileNameMatch[1];
        }
      }

      const file = new Blob([response.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);
      const link = document.createElement("a");
      link.href = fileURL;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(fileURL);

      Noti("success", "فایل نسخه با موفقیت آماده شد");
    },
    onError: async (error: any) => {
      // 3. HANDLE ERRORS (4xx/5xx) WHERE THE BODY IS A BLOB
      if (error.response?.data instanceof Blob) {
        try {
          const text = await error.response.data.text();
          const errorData = JSON.parse(text);
          Noti("error", errorData.msg || "خطا در دریافت فایل نسخه");
        } catch (e) {
          Noti("error", "خطا در دریافت فایل نسخه");
        }
      } else {
        Noti("error", error?.response?.data?.msg || "خطا در برقراری ارتباط");
      }
    },
  });
};

export {
  useSakhadSendOtp,
  useSakhadLogin,
  useSakhadVerifyOtp,
  useSakhadConfirmLogin,
  useSakhadGetCaptcha,
  useGetAllServiceListByType,
  useSakhadVerifyCaptcha,
  useIsSakhadProviderLoggedIn,
  useSakhadGetSubHistory,
  useSakhadPrintPrescription,
  useSakhadGetServiceByTypeAndCode,
  useSakhadGetAllConsumptionListByShape,
  useSakhadGetAllConsumptionInstructionListByShape,
  // useSakhadLogout,
};
